import type { ObfuscatedLoanIdentifier } from '~/common/hooks/useUrl';

export function validateObfuscatedIdentifier(
  identifier: ObfuscatedLoanIdentifier | null,
): asserts identifier is ObfuscatedLoanIdentifier {
  if (!identifier) {
    throw new Error('obfuscatedLoanIdentifier is required');
  }
}
